import { Component, ErrorInfo, ReactNode } from 'react';
import { PremiumButton } from './ui/PremiumButton';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-dvh bg-sheriff-bg flex items-center justify-center p-6">
          <div className="max-w-md w-full bg-sheriff-bg-elevated border border-sheriff-border rounded-2xl p-6 text-center">
            <div className="text-6xl mb-4">⚠️</div>
            <h1 className="text-xl font-bold text-white mb-2">Что-то пошло не так</h1>
            <p className="text-sm text-sheriff-text-secondary mb-4">
              {this.state.error?.message || 'Произошла ошибка при загрузке приложения'}
            </p>
            <PremiumButton
              onClick={() => window.location.reload()}
              variant="primary"
              fullWidth
            >
              Перезагрузить
            </PremiumButton>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

